import { RegularHistoryAcceptanceActivityPage } from "@/features/regular-document/pages/acceptance-activity-document/RegularHistoryAcceptActivity";

const RegularHistoryAcceptanceActivity = () => {
  return <RegularHistoryAcceptanceActivityPage />;
};

export default RegularHistoryAcceptanceActivity;
